import {Button, Table} from 'antd'
import {billding_unsubscribeChannel_Api, billling_getChannelSubscriptionsByLogin_Api} from 'apis'
import {channelModel} from 'apis/model'
import {channelSubscriptionSchema} from 'apis/schema'
import {handleconfirm} from 'components/Confirm'
import _ from 'lodash'
import {createAsyncAction} from 'modules/asyncCache'
import {AsyncByActionWithNotify} from 'modules/asyncCache/components/Async'
import useDispatchAsyncAction from 'modules/asyncCache/useDispatchAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {selectEntities} from 'redux/selectors'
import CurrencyAmount from './CurrencyAmount'
import getLinkToDetail from 'helpers/getLinkToDetail'
import {formatDate} from "../../../helpers/datetimeHelpers";

const BillHistoryTableContext = React.createContext(
  {
    dataSource: []
  }
)
const BillHistoryTable = () => {
  const t = useTranslate()
  const columns = [
    {
      title: t('channel'),
      dataIndex: 'channel',
      key: 'channel',
      width: 16,
      render: item => (
        <Link
          className="font-bold"
          to={getLinkToDetail(
            item
          )}>
          {channelModel.getTitle(item)}
        </Link>
      )
    },
    {
      title: t('fee'),
      dataIndex: 'price',
      align: "right",
      key: 'price',
      width: 10,
      render: number => (
        <CurrencyAmount>
          {number}
        </CurrencyAmount>
      )
    },
    {
      title: t('status'),
      key: 'status',
      dataIndex: 'status',
      width: 10
    },
    {
      title: t('renew / expires on'),
      key: 'to',
      dataIndex: 'to',
      width: 16
    },
    {
      title: t('manage'),
      key: 'manage',
      dataIndex: 'channel',
      width: 12,
      fixed: 'right',
      render: (
        channel = {}
      ) => (
        <AsyncByActionWithNotify>
          {(data, dispath) => (
            <Button
              type="link"
              onClick={() => {
                handleconfirm({
                  title: t(
                    'do you want to cancel?'
                  ),
                  onOk: () => {
                    dispath(
                      createAsyncAction(
                        {
                          apiInfo: billding_unsubscribeChannel_Api,
                          query: {
                            ':channel_id': channelModel.getId(
                              channel
                            )
                          }
                        }
                      )
                    )
                  }
                })
              }}
              loading={data.isLoading}
              block
              className="p-0"
              size="large">
              {t('cancel')}
            </Button>
          )}
        </AsyncByActionWithNotify>
      )
    }
  ]
  const [
    current,
    setCurrent
  ] = useState(1)
  const [
    {
      response,
      result = [],
      isLoading,
      success
    },
    handleDispatchAsyncAction
  ] = useDispatchAsyncAction()
  useEffect(() => {
    handleDispatchAsyncAction(
      createAsyncAction({
        apiInfo: billling_getChannelSubscriptionsByLogin_Api,
        values: {
          page: current
        }
      })
    )
  }, [
    current,
    handleDispatchAsyncAction
  ])
  const handleTableChange = pagination => {
    setCurrent(pagination.current)
  }
  const mapPagination = (
    response,
    current
  ) => ({
    pageSize:
      _.get(
        response,
        'data.meta.pagination.per_page'
      ) || 10,
    current,
    total: _.get(
      response,
      'data.meta.pagination.total'
    )
  })
  const data = useSelector(state =>
    selectEntities(
      state,
      result,
      [channelSubscriptionSchema],
      []
    )
  )
  const dataSource = data.map(item => ({
    ...item,
    price: _.get(item, 'channel.price'),
    channel: _.get(item, 'channel'),
    status: _.get(item, 'status_text'),
    started: formatDate(
      _.get(item, 'started')
   ,'LL'),
    from: formatDate(
      _.get(item, 'from')
    ,'LL'),
    to: formatDate(
      _.get(item, 'to')
    ,'LL')
  }))
  return (
    <BillHistoryTableContext.Provider
      dataSource={dataSource}>
      <Table
        scroll={{x: 800}}
        loading={isLoading}
        columns={columns}
        pagination={mapPagination(
          response,
          current
        )}
        dataSource={dataSource}
        onChange={handleTableChange}
      />
    </BillHistoryTableContext.Provider>
  )
}

export const ManageSubscriptionChannels = () => {
  return (
    <div className="-mx-2 flex flex-col verticalList__large">
      <div className="p-2">
        <BillHistoryTable/>
      </div>
    </div>
  )
}
export default ManageSubscriptionChannels
